import cssVars from 'css-vars-ponyfill';
import i18n from './i18n';
import vuetify from './vuetify';

cssVars();

export {
  i18n, vuetify,
};
